<mat-icon [class.half-rounded-bg]="roundedBg == 'half'"
          [class.full-rounded-bg]="roundedBg == 'full'"
          [class.pointer]="isPointer"
          [class.disabled-icon]="disabled"
          [ngClass]="className"
          [style.color]="resolvedColor"
          [style.font-variation-settings]="fontVariationSettings"
          [style.width.px]="size"
          [style.height.px]="size"
          [style.font-size.px]="size"
          fontSet="material-symbols-outlined">
    {{ name }}
</mat-icon>
